var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "project-copy-modal",
        pivotY: 0.2,
        width: "590",
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-img-container" }, [
        _c("img", {
          staticClass: "modal-img",
          attrs: { src: _vm.titleImageProject(_vm.projectGUID) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("project-copy-modal")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title" }, [
        _vm._v("\n        Копировать проект\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-text" }, [
        _vm._v("\n        Создать копию проекта"),
        _c("span", { staticClass: "bold-text" }, [
          _vm._v(" " + _vm._s(_vm.nameProject))
        ]),
        _vm._v(" с именем:\n    ")
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.nameNewProject,
            expression: "nameNewProject"
          }
        ],
        staticClass: "modal-text-input",
        attrs: { type: "text" },
        domProps: { value: _vm.nameNewProject },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.nameNewProject = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-button", on: { click: _vm.copyProject } },
        [_vm._v("\n        Создать\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }